import { t } from "@superset-ui/core";
import CategoricalScheme from "../../CategoricalScheme";

const schemes = [
    {
        id: "Innodep001",
        label: "Innodep 001",
        colors: [
            "#17becf",
            "#bcbd22",
            "#7f7f7f",
            "#e377c2",
            "#8c564b",
            "#f1c232",
            "#d62728",
            "#2749aa",
            "#2986cc",
            "#f44336",
        ],
    },
    {
        id: "Innodep002",
        label: "Innodep 002",
        colors: ["#29aacc", "#f44336", "#d62428", "#f1c232", "#8c564b", "#e377c2", "#7f7f7f", "#bcbd22", "#17becf"],
    },
    {
        id: "Innodep003",
        label: t("Blue Gradient"),
        colors: ["#091A7A", "#102693", "#1939B7", "#254EDB", "#3366FF", "#6690FF", "#84A9FF", "#ADC8FF", "#DCE4FF"],
    },
    {
        id: "Innodep004",
        label: t("Sky Gradient"),
        colors: ["#141438", "#222243", "#363654", "#4F4F64", "#6D6D75", "#A3A3AC", "#CCCCD5", "#EAEAF1", "#CCFDFF"],
    },
    {
        id: "Innodep005",
        label: t("Pupple Gradient"),
        colors: ["#300847", "#470B68", "#5D0E88", "#7C1A99", "#AB3291", "#D94788", "#EE6C8C", "#F5999A", "#FAC7A6"],
    },
    {
        id: "Innodep006",
        label: t("GreyBlue Gradient"),
        colors: ["#244776", "#3C658E", "#608DB1", "#8BB8D3", "#BFE5F6", "#CFEFF9", "#DAF6FC", "#E7FBFE", "#F3FEFE"],
    },
    {
        id: "Innodep007",
        label: t("PastelWine Gradient"),
        colors: ["#61184F", "#75295A", "#92416D", "#AE5E82", "#CB819B", "#DFA2B2", "#EFBBC3", "#F9D5D7", "#FCEAE9"],
    },
    {
        id: "Innodep008",
        label: t("BlueBlack Gradient"),
        colors: ["#141438", "#222243", "#363654", "#4F4F64", "#6D6D75", "#A3A3AC", "#CCCCD5", "#EAEAF1", "#F4F4F8"],
    },
    {
        id: "Innodep009",
        label: t("GreenBlack Gradient"),
        colors: ["#14381B", "#224326", "#365437", "#50644F", "#6E756D", "#A5ACA3", "#CFD5CC", "#ECF1EA", "#F6F8F4"],
    },
    {
        id: "Innodep010",
        label: t("TreeBlack Gradient"),
        colors: ["#383114", "#433E22", "#544F36", "#64614F", "#75746D", "#ACABA3", "#D5D4CC", "#F1F0EA", "#F8F7F4"],
    },
    {
        id: "Innodep011",
        label: t("Vivid Green Gradient"),
        colors: [
            "#00A388",
            "#1CAD8A",
            "#39B78D",
            "#55C28F",
            "#71CC91",
            "#8ED694",
            "#AAE096",
            "#C6EB98",
            "#E3F59B",
            "#FFFF9D",
        ],
    },
    {
        id: "Innodep012",
        label: t("Vivid Blue Gradient"),
        colors: ["#111558", "#191E80", "#234797", "#2B6FAE", "#3495C6", "#8DD0D0", "#CCE8C8"],
    },
    {
        id: "Innodep013",
        label: t("Vivid Pupple Gradient"),
        colors: ["#300847", "#470B68", "#5D0E88", "#7C1A99", "#AB3291", "#D94788", "#EE6C8C", "#F5999A", "#FAC7A6"],
    },
    {
        id: "Innodep014",
        label: t("Lavendar Gradient"),
        colors: ["#6D5A74", "#987094", "#9A86B3", "#C4BFE3", "#E1DBF0", "#F7F7E5"],
    },
    {
        id: "Innodep015",
        label: t("Newjeans Gradient"),
        colors: ["#00715A", "#008691", "#0098C1", "#37A6E3", "#95B2F7", "#D7BFFF", "#F7F7E5"],
    },
    {
        id: "Innodep016",
        label: t("Sea Salt Gradient"),
        colors: ["#B6ABAB", "#C6D4D2", "#A9C5B9", "#C5DCD5", "#DBD2D1", "#E6F0EF"],
    },
    {
        id: "Innodep017",
        label: t("Light Pupple Gradient"),
        colors: ["#948490", "#B2ABC1", "#B596A5", "#DBCEDF", "#E5DAE8", "#ECEED1"],
    },
    {
        id: "Innodep018",
        label: t("Lego 6"),
        colors: ["#ae0e0e", "#23206a", "#F2B705", "#F2E8DC", "#0455BF", "#010440"],
    },
    {
        id: "Innodep019",
        label: t("France 6"),
        colors: ["#4755BF", "#E74C3C", "#F0F0F2", "2C3E50", "#0A2F5B", "#9E0A19"].reverse(),
    },
    {
        id: "Innodep020",
        label: t("Cyberpunk 5"),
        colors: ["#152198", "#6137bb", "#9d50dd", "#d76aff", "#f2a4cb"],
    },
    {
        id: "Innodep021",
        label: t("Bud Tree 7 Gradient"),
        colors: ["#004056", "#206672", "#4b8d88", "#7fb49b", "#bcdab0", "#d9ffd3", "#ffffcb"],
    },
    {
        id: "Innodep022",
        label: t("Rainbow 6"),
        colors: ["#CE4D45", "#2AA876", "#FFD265", "#F19C65", "#0a4983", "#0A7B83"],
    },
    {
        id: "Innodep023",
        label: t("Playground 6"),
        colors: ["#6F56A6", "#548C62", "#F29F05", "#F28379", "#F2E8DF", "#283459"],
    },
    {
        id: "Innodep024",
        label: t("Innodep 7"),
        colors: ["#2A4353", "#3c5679", "#135487", "#5CA2BE", "#989DA4", "#D5D8DD", "#F2F2F0"],
    },
    {
        id: "Innodep025",
        label: t("Night Sunset 10 Gradient"),
        colors: [
            "#0d4680",
            "#4b4c8b",
            "#745191",
            "#985691",
            "#b85e8d",
            "#d26986",
            "#e5787e",
            "#f38c75",
            "#f9a26f",
            "#faba6e",
        ],
    },
    {
        id: "Innodep026",
        label: t("Phytoncide 8 Gradient"),
        colors: ["#314032", "#435946", "#ADBFA8", "#D9D6D0", "#F2F2F2", "#BEBF99", "#465902", "#545e10"],
    },
    {
        id: "Innodep027",
        label: t("Magical Girl 9"),
        colors: ["#F288AF", "#7672F2", "#9794F2", "#C3C2F2", "#F2BDDA", "#F2F2F2", "#7285F2", "#4962F2", "#F238B1"],
    },
    {
        id: "Innodep028",
        label: t("Spring Flower 15 Gradient"),
        colors: [
            "#f2ed69",
            "#ffe067",
            "#ffd36a",
            "#ffc771",
            "#ffbb7a",
            "#ffb186",
            "#ffa892",
            "#ffa09e",
            "#ff9baa",
            "#ff98b4",
            "#f195bd",
            "#e094c3",
            "#ce94c7",
            "#bb94c9",
            "#a893c7",
        ],
    },
    {
        id: "Innodep029",
        label: t("Deep Ocean 9"),
        colors: ["#0E1D2E", "#1C3C74", "#454F78", "#2F5E90", "#6F7B93", "#54A49C", "#4C7C9D", "#6AC2D0", "#B4C5D5"],
    },
    {
        id: "Innodep30",
        label: t("Cutie Baby 5"),
        colors: ["#3E81DD", "#ff98b4", "#FAD97B", "#F29D73", "#7FFAC8"],
    },
    {
        id: "Innodep031",
        label: t("New Jeans 7 Gradient"),
        colors: ["#00715A", "#008691", "#0098C1", "#37A6E3", "#95B2F7", "#D7BFFF", "#F7F7E5"],
    },
    {
        id: "Innodep032",
        label: t("Neon Purple 11 Gradient"),
        colors: [
            "#b400ff",
            "#f500db",
            "#ff00b3",
            "#ff008b",
            "#ff0065",
            "#ff4641",
            "#ff7913",
            "#ffa000",
            "#ffc000",
            "#f0dc00",
            "#d0f523",
        ],
    },
    {
        id: "Innodep033",
        label: t("Innodep Blue6"),
        colors: ["#62B7E7", "#219DD6", "#4283C5", "#0068B4", "#004A82", "#003077"],
    },
    {
        id: "Innodep034",
        label: t("Innodep Blue6 v2"),
        colors: ["#003077", "#004A82", "#0068B4", "#4283C5", "#219DD6", "#62B7E7"],
    },
    {
        id: "Innodep035",
        label: t("Innodep Blue3"),
        colors: ["#62B7E7", "#0068B4", "#003077"],
    },
    {
        id: "Innodep036",
        label: t("Innodep Blue3 v2"),
        colors: ["#003077", "#0068B4", "#62B7E7"],
    },
    {
        id: "Innodep037",
        label: t("Dark Blue Gray"),
        colors: ["#0068B4", "#767979"],
    },
    {
        id: "Innodep038",
        label: t("Dark Blue Gray v2"),
        colors: ["#767979", "#0068B4"],
    },
    {
        id: "Innodep039",
        label: t("Light blue Gray"),
        colors: ["#62B7E7", "#767979"],
    },
    {
        id: "Innodep040",
        label: t("Light blue Gray v2"),
        colors: ["#767979", "#62B7E7"],
    },
    {
        id: "Innodep041",
        label: t("Traffic3"),
        colors: ["#E65B70", "#E6D15B", "#5CE6D2"],
    },
    {
        id: "Innodep042",
        label: t("Traffic3 v2"),
        colors: ["#5CE6D2", "#E6D15B", "#E65B70"],
    },
    {
        id: "Innodep043",
        label: t("Light blue Gray"),
        colors: ["#62B7E7", "#E65B70", "#E6D15B"],
    },
    {
        id: "Innodep044",
        label: t("Light blue Gray v2"),
        colors: ["#E65B70", "#62B7E7", "#5CE6D2"],
    },
].map((s) => new CategoricalScheme(s));

export default schemes;
